<template>
<v-row
      no-gutters>
  <v-col v-if="item.zContainer || !item.children.length"
   :class="item.cssClassDetail" :style="{ height: item.height }">
   <!-- :style="{ ...item.colCSS, ...{ height: item.height } -->
    <v-row
      no-gutters
      class="flex-nowrap"
      v-if="item.job_count && (!showDetails || !detailDef.titleWidths.length)"
    >
      <v-col
        v-for="(m, mi) in visibleMeasures"
        :key="'m' + mi"
        class="col-resizable"
        :style="{ minWidth: detailDef.measureWidths[mi]?.percent ?? '100%', maxWidth: detailDef.measureWidths[mi]?.percent ?? '100%' }"
      >
        <div v-if="detailDef.measureWidths[mi]?.key" class="col-resize-handle" title="Drag to resize; double-click to reset"
          @click.stop
          @dblclick.stop="$emit('resetColumnWidth', detailDef.measureWidths[mi].key)"
          @pointerdown.stop.prevent="$emit('resizeColumn', $event, detailDef.measureWidths[mi].key, detailDef.measureWidths[mi].px)"></div>
        <MeasureDisplay
        class="measure-column"
          :item="item"
          :measure="m"
          :selectable="m.type === 'job_count'"
          @click="$emit('selectJob', item)"
          @showDocList="$emit('openDocListMenu', ...arguments)"
          @showLinkedDocs="$emit('showLinkedDocs', ...arguments)"
          @drilldown="$emit('drilldown', ...arguments)"
        ></MeasureDisplay
      ></v-col>
    </v-row>
    <template v-if="showDetails">
      <v-row
        class="flex-nowrap"
        no-gutters
        v-for="(g, gi) in item.children.filter(
          (x) => x && x.dIndex >= vScroll.dStart && x.dIndex <= vScroll.dEnd
        )"
        :key="'g' + gi"
        :class="g.cssClass"
        ><v-col
          v-if="g.headerColumns.length"
          style="max-width: 37px; padding-left: 12px; padding-top: 4px"
        >
          <v-checkbox v-model="g.selected" dense hide-details color="green" @click="$emit('selectJob', g)">
          </v-checkbox>
        </v-col>
        <v-col
          v-if="detailDef.titleWidths.length"
          :style="{ maxWidth: detailDef.titleSectionWidth }"
          class="detail-column"
        >
          <v-row
            class="flex-nowrap"
            no-gutters
            :class="
              g.headerColumns.length > 1
                ? 'category_detail'
                : null
            "
          >
            <v-col v-if="!g.headerColumns.length"></v-col>
            <v-col
              v-for="(h, hi) in g.headerColumns"
              :key="'g' + gi + 'h' + hi"
              class="z-detail col-resizable"
              :style="{ minWidth: detailDef.titleWidths[hi]?.percent ?? '100%', maxWidth: detailDef.titleWidths[hi]?.percent ?? '100%' }"
              :title="detailDef.titleWidths[hi]?.title + ': ' + h.title"
            >
              <!-- a single full-width detail column resizes via the cell (H) handle;
                   its own handle would overlap it at the same edge -->
              <div v-if="detailDef.titleWidths[hi]?.key && (detailDef.titleWidths.length > 1 || detailDef.measureWidths.length)"
                class="col-resize-handle" title="Drag to resize; double-click to reset"
                @click.stop
                @dblclick.stop="$emit('resetColumnWidth', detailDef.titleWidths[hi].key)"
                @pointerdown.stop.prevent="$emit('resizeColumn', $event, detailDef.titleWidths[hi].key, detailDef.titleWidths[hi].px)"></div>
              <div
                v-if="h.doc_id"
                @contextmenu="$emit('openDocActionsMenuContext', $event, h)"
                :title="h.title + ': Click to view ' + catalogueDocType.docType"
              >
                <DocSummary
                  :doc_id="h.doc_id"
                  :text="h.title" showAsLink
                  :searchTerms="searchTerms"
                  @openDocument="$emit('openDocument', $event)"
                  @copyDocument="$emit('copyDocument', $event)"
                  @selectDocument="$emit('selectJob', g)"
                ></DocSummary>
                <!-- <span :title="h.title">{{ h.title }} </span> -->
                <v-badge
                  color="red"
                  v-if="h.match_count && 1 === 0"
                  :content="h.match_count"
                  offset-y="10"
                >
                  <v-icon
                    class="float-fight"
                    color="blue"
                    small
                    title="click to compare similar docments"
                    @click="$emit('showMatches', g)"
                    >mdi-content-duplicate</v-icon
                  >
                </v-badge>
              </div>
              <div
                v-else-if="h.node"
                :style="allowDragNode ? 'hover' : 'cursor: pointer'"
                v-on:dragstart="$emit('dragStart', $event, h)"
                :draggable="allowDragNode && h.node && !h.node.actionPending && h.node.level > 1"
                :id="'dragSource' + h.value"
                :class="{
                  draggable:
                    allowDragNode && h.node && !h.node.actionPending && h.node.level > 1,
                }"
              >
                <HierarchyNodeDisplay
                  :node="h.node"
                  displayPlain
                  isLink
                  :nodeActionsAlignment="h.nodeActionsAlignment"
                  :searchTerms="searchTerms"
                  :hideNodeActions="hideNodeActions"
                  @action="$emit('doMenuAction', $event, null, null, g)"
                  @viewNodeDoc="$emit('viewNodeDoc', $event, g)"
                  @removeActionPending="$emit('removeAdditionNode', h.node)"
                ></HierarchyNodeDisplay>
              </div>
              <div v-else>
                <span
                  :class="
                    detailDef.titleWidths[hi].valueDisplayType === 'chip'
                      ? 'detail-cell-chip'
                      : ''
                  "
                  ><v-icon small v-if="detailDef.titleWidths[hi].valueIcon">{{detailDef.titleWidths[hi].valueIcon}}</v-icon>
                  <span v-html="utils.highlightSearchTerms((h.title_prefix ? h.title_prefix + ': ' : '') + h.title, searchTerms)"></span>
                </span>
              </div>
              <v-row v-if="h.nestedColumns.length" no-gutters>
                <v-col>
                  <template v-for="(nc, nci) in h.nestedColumns">
                    <span
                      v-if="nc.valueDisplayType === 'chip'"
                      :key="'g' + gi + 'h' + hi + 'nc' + nci"
                      :class="nc.cssClass"
                    ><v-icon small v-if="nc.valueIcon">{{nc.valueIcon}}</v-icon>
                    <span v-html="utils.highlightSearchTerms(nc.title, searchTerms)"></span>
                      <!-- {{ nc.title }} -->
                    </span>
                    <div
                      v-else
                      :key="'g' + gi + 'h' + hi + 'nc' + nci"
                      :class="nc.cssClass"
                    ><v-icon small v-if="nc.valueIcon">{{nc.valueIcon}}</v-icon>
                    <span v-html="utils.highlightSearchTerms(nc.title, searchTerms)"></span>
                      <!-- {{ nc.title }} -->
                    </div>
                  </template>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-col>
        <v-col
          v-if="detailDef.measureWidths.length"
          :style="{ maxWidth: detailDef.measureSectionWidth }"
        >
          <v-row no-gutters class="flex-nowrap">
            <v-col
              v-for="(m, mi) in visibleMeasures"
              class="col-resizable"
              :style="{ minWidth: detailDef.measureWidths[mi]?.percent ?? '100%', maxWidth: detailDef.measureWidths[mi]?.percent ?? '100%' }"
              :key="'g' + gi + 'm' + mi"
            >
              <div v-if="detailDef.measureWidths[mi]?.key" class="col-resize-handle" title="Drag to resize; double-click to reset"
                @click.stop
                @dblclick.stop="$emit('resetColumnWidth', detailDef.measureWidths[mi].key)"
                @pointerdown.stop.prevent="$emit('resizeColumn', $event, detailDef.measureWidths[mi].key, detailDef.measureWidths[mi].px)"></div>
              <MeasureDisplay
                class="measure-column"
                :item="g"
                :measure="m"
                :backColour="g.colour"
                @click="$emit('selectJob', g)"
                @showDocList="$emit('openDocListMenu', ...arguments)"
                @showLinkedDocs="$emit('showLinkedDocs', ...arguments)"
                @drilldown="$emit('drilldown', ...arguments)"
              ></MeasureDisplay
            ></v-col>
          </v-row>
        </v-col> </v-row
    ></template>
  </v-col>
  <v-col v-else>
    <v-row no-gutters class="flex-nowrap">
      <template v-for="(c, ci) in item.children">
        <v-col
          :key="'ch' + ci"
          :style="{ minWidth: c.colCSS?.maxWidth, maxWidth: c.colCSS?.maxWidth }"
        >
          <HierarchyViewColumnDetailAlt
            :item="c"
            :detailDef="detailDef"
            :visibleMeasures="visibleMeasures"
            :showDetails="showDetails"
            :catalogueDocType="catalogueDocType"
            :vScroll="vScroll"
            :searchTerms="searchTerms"
            :hideNodeActions="hideNodeActions"
            @selectJob="$emit('selectJob', ...arguments)"
            @selectItem="$emit('selectItem', ...arguments)"
            @openDocListMenu="$emit('openDocListMenu', ...arguments)"
            @openDocActionsMenuContext="
              $emit('openDocActionsMenuContext', ...arguments)
            "
            @openDocument="$emit('openDocument', ...arguments)"
            @copyDocument="$emit('copyDocument', ...arguments)"
            @showMatches="$emit('showMatches', ...arguments)"
            @dragStart="$emit('dragStart', ...arguments)"
            @doMenuAction="$emit('doMenuAction', ...arguments)"
            @viewNodeDoc="$emit('viewNodeDoc', ...arguments)"
            @removeAdditionNode="$emit('removeAdditionNode', ...arguments)"
            @showLinkedDocs="$emit('showLinkedDocs', ...arguments)"
            @drilldown="$emit('drilldown', ...arguments)"
            @resizeColumn="$emit('resizeColumn', ...arguments)"
            @resetColumnWidth="$emit('resetColumnWidth', ...arguments)"
          ></HierarchyViewColumnDetailAlt
        ></v-col>
      </template>
    </v-row>
  </v-col>
</v-row>
</template>
<script>
import HierarchyNodeDisplay from "@/components/hierarchy/cHierarchyNodeDisplay";
import MeasureDisplay from "@/components/jobArchitecture/MeasureDisplay.vue";
import DocSummary from "@/components/common/DocViewPopUp";
import utils from "@/common/utils.js";
export default {
  name: "HierarchyViewColumnDetailAlt",
  props: {
    item: Object,
    detailDef: Object,
    visibleMeasures: Array,
    showDetails: Boolean,
    catalogueDocType: Object,
    vScroll: Object,
    allowDragNode: Boolean,
    searchTerms: { type: [], required: false },
    hideNodeActions: { type: Boolean, required: false },
  },
  data: function () {
    return {
      utils: utils,
    };
  },
  components: {
    HierarchyNodeDisplay,
    MeasureDisplay,
    DocSummary,
  },
  watch: {},
  computed: {},
  created: function () {},
  methods: {},
};
</script>
  <style scoped lang="scss">
.category_detail {
  padding: 0px;
  margin-left: 2px;
  margin-right: 2px;
}
.detail-column {
  min-height: 50px;
}
</style>